// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zOw8","colBig":"styles_colBig__2hn6e","colSmall":"styles_colSmall__yUlvh"};